<template lang="html">
  <div class="note">
    <h2>2025 Anniversary Year</h2>
    <p>
      2025 marks the 90th anniversary of Christo and Jeanne-Claude's birth, as
      well as key anniversaries of three of their most iconic projects.
    </p>

    <button
      v-for="(item, index) in navi"
      class="l"
      @click="navigate(index)"
      v-bind:key="index"
    >
      {{ item.title }}
    </button>
  </div>
</template>

<script>
export default {
  name: "ElAnniversaryNote",
  data() {
    return {
      navi: [
        {
          title: "More Information",
          path: "/2025",
        },
      ],
    };
  },
  methods: {
    navigate(i) {
      if (this.$route.path == this.navi[i].path) {
        this.scrollDown();
      } else {
        this.$router.push({ path: this.navi[i].path });
      }
    },
    scrollDown() {
      let newPos;
      if (window.innerWidth > 600) {
        newPos = window.innerHeight - 30;
      } else {
        newPos = window.innerHeight;
      }
      window.scrollTo({
        top: newPos,
        left: 0,
        behavior: "smooth",
      });
    },
  },
};
</script>

<style lang="css" scoped>
/* Styles will be inherited from parent component or global styles */
</style>
